module.exports = __webpack_public_path__ + "static/media/sell-banner.5424ec71.png";